<template>
    <div class="text-center py-1 lg:px-1 w-full">
    <div class="p-2 bg-yellow-800 items-center text-yellow-100 leading-none lg:rounded-full flex lg:inline-flex w-full"
      role="alert">
      <span class="flex rounded-full bg-yellow-900 uppercase px-2 py-1 text-md font-bold mr-3">
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#e3e3e3">
          <path d="M0 0h24v24H0z" fill="none" />
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" />
        </svg>
      </span>
      <span class="mr-2 text-left text-xs flex-auto">{{
        $t('INBOX_MGMT.SETTINGS_POPUP.ALERT_SYNC_TEMPLATES')
        }}</span>
    </div>
  </div>
    <div>New Connection</div>
    <Divider type="solid" />
  <div class="flex flex-col gap-4">
    <div class="text-sm text-gray-500">
      <NextButton
        class="ml-2"
        icon="i-lucide-arrow-left"
        label="Atras"
        @click="back" />
      <NextButton
        class="ml-2"
        icon="i-lucide-arrow-right"
        label="Siguiente"
        @click="go" />
    </div>
  </div>
</template>
<script setup>
import { ref, defineEmits } from 'vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

const emit = defineEmits(['change-step']);

const go = () => {
  console.log('go');
};

const back = () => {
  emit('change-step', 'first');
};
</script>